import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';

@Component({
  selector: 'app-incubator',
  standalone: false,
  templateUrl: './incubator.component.html',
  styleUrl: './incubator.component.scss'
})
export class IncubatorComponent implements OnInit, OnDestroy {
  title = 'Incubator Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  systemForm: FormGroup;
  private subscriptions = new Subscription();
  system: any[]=[]
  // isCardView: boolean = true;
  cols: any[] = [
    { field: 'name', header: ' Name', filterType: 'text', width: '100px', minWidth: '150px', maxWidth: '300px'  },
    { field: 'description', header: 'Description', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px'  },

  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false;
  schemes: any
  totalRecords: number = 0;

  constructor(private fb: FormBuilder, private api: ApiService, private messageService: MessageService , private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // this.getSystem();
    this.systemForm = this.fb.group({
       name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      description: ['', Validators.required],
      selectedOptions: [[]]
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
     const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/incubator/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
       let resp = res.data || res.results
      this.system = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      }));
       this.totalRecords = res.count || 0
    });
    this.subscriptions.add(sub);
  }
  getScheme() {
    const sub = this.api.getAPI('/master/scheme/').subscribe((res: any) => {
      this.schemes = res;
    })
    this.subscriptions.add(sub);
  }

  addSystem() {
    this.systemForm.reset();
    this.systemForm.enable()
    this.getScheme();
    this.showDialog = true;

  }
  onSubmitadd() {
    if (this.systemForm.valid) {
      const selectedIds = this.systemForm.value.selectedOptions;
      let payload = {
        name: this.systemForm.get('name')?.value,
        description: this.systemForm.get('description')?.value,
        scheme: selectedIds
      }
      const sub = this.api.postAPI('/master/incubator/', payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Incubator submitted successfully'
          });
          this.showDialog = false;
          this.systemForm.reset();
          this.getSystem();


        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'failed',
            detail: res.name
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  viewMode = false;
viewSystem(rowData: any) {
  this.viewMode = true;
   if (rowData && rowData.id) {
      this.getScheme();
    this.isUpdatedialog = true
    this.selectedsystem = rowData;
    this.systemForm.patchValue({
      name: rowData.name,
      description: rowData.description,
      selectedOptions: rowData.scheme || []
    })
    this.systemForm.disable()
    }
}

  updateSystem(equipment: any): void {
    this.getScheme();
    this.viewMode = false;
    this.systemForm.enable()
    this.isUpdatedialog = true
    this.selectedsystem = equipment;
    this.systemForm.patchValue({
      name: equipment.name,
      description: equipment.description,
      selectedOptions: equipment.scheme || []
    })
  }


  onSubmitEq() {
    let sectionId = this.selectedsystem.id
    const selectedIds = this.systemForm.value.selectedOptions;
    let payload = {
      name: this.systemForm.get('name')?.value,
      description: this.systemForm.get('description')?.value,
      scheme: selectedIds
    }
    const sub = this.api.putAPI(`/master/incubator/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Incubator updated successfully'
        });
        this.isUpdatedialog = false;
        this.systemForm.reset();
        this.getSystem()
      } else {
        this.messageService.add({
          severity: 'failed',
          summary: 'Failed',
          detail: res.detail
        });
      }
    });
    this.subscriptions.add(sub);
    this.isUpdatedialog = false;
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/incubator/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Incubator Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }
    get canEditSetup(): boolean {
  return this.permissionService.hasPrivilege('/master/incubator', 'Edit') ||
         this.permissionService.hasPrivilege('/master/incubator', 'Delete')||
         this.permissionService.hasPrivilege('/master/incubator', 'View');
}
}
